const WHOLE_NUMBER = /^\d+$/;

/**
 * Converts a folder id to the JSON number the server's strict schema requires.
 *
 * @param {number|string|null|undefined} folderId - A number, or a string such as react-router's useParams gives.
 * @returns {number|null} The id, or null when it is not a whole number (so that no request is sent for it).
 */
export const toFolderIdNumber = (folderId) => {
    if (typeof folderId === "number") {
        return Number.isSafeInteger(folderId) ? folderId : null;
    }
    if (typeof folderId === "string" && WHOLE_NUMBER.test(folderId)) {
        const id = Number(folderId);
        return Number.isSafeInteger(id) ? id : null;
    }
    return null;
};
